import { Asset, Icon, Link, TAsset, TIcon, UtilsBlock } from '@hz-design-system/web-ui';
import React, { useState } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { TListingQualityMark } from 'types/TListing';
import { trackGAEvent } from '../../../utils/gaTracking';

import Classes from './QualityMark.module.scss';

type TQualityMarkProps = {
  qualityMark: TListingQualityMark;
};

let DetailsModal;

const QualityMark = ({ qualityMark }: TQualityMarkProps) => {
  const { t } = useI18nContext();
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [isDetailsModalLoaded, setDetailsModalLoaded] = useState(false);

  const hasDetails = !!qualityMark.detailsContent;
  const hasDetailsLink = !!qualityMark.detailsUrl;
  const detailsLinkText =
    hasDetailsLink && qualityMark.type === 'BATTERY_STATE_OF_HEALTH'
      ? t('listing.trustIndicators.qualityMarks.reportLink')
      : t('listing.trustIndicators.qualityMarks.documentLink');

  const loadDetailsModal = async () => {
    if (!isDetailsModalLoaded) {
      try {
        DetailsModal = (await import(/* webpackChunkName: "DetailsModal" */ './DetailsModal')).default;
        setDetailsModalLoaded(true);
      } catch {}
    }
  };

  const handleOpenModal = async () => {
    await loadDetailsModal();
    setShowDetailsModal(true);
    trackGAEvent('QualityMarkDetailsClicked', qualityMark.type);
  };

  const handleCloseModal = () => {
    setShowDetailsModal(false);
  };

  return (
    <div className={Classes.root}>
      {qualityMark.logo ? (
        <span className={Classes.logoWrapper}>
          <Asset.Fluid name={qualityMark.logo as TAsset} />
        </span>
      ) : (
        <span className={Classes.iconWrapper}>
          <Icon name={qualityMark.icon as TIcon} className={Classes.icon} />
        </span>
      )}

      <div>
        <p className={Classes.title}>{qualityMark.name}</p>
        {/* eslint-disable-next-line react/no-danger */}
        <p className={Classes.description} dangerouslySetInnerHTML={{ __html: qualityMark.description }} />
        {hasDetails && (
          <UtilsBlock mt="xxs">
            <Link onClick={handleOpenModal}>{t('listing.trustIndicators.warranties.cta')}</Link>
          </UtilsBlock>
        )}
        {hasDetailsLink && (
          <UtilsBlock mt="xxs">
            <Link href={qualityMark.detailsUrl} target="_blank" rel="noopener noreferrer nofollow">
              {detailsLinkText}
            </Link>
          </UtilsBlock>
        )}
      </div>

      {hasDetails && showDetailsModal && isDetailsModalLoaded && (
        <DetailsModal
          title={qualityMark.name}
          content={qualityMark.detailsContent}
          disclaimer={qualityMark.disclaimer}
          handleClose={handleCloseModal}
          logo={qualityMark.logo}
        />
      )}
    </div>
  );
};

export default QualityMark;
